export const ExportDestinations = ["GCS", "S3"] as const;
export type ExportDestinationType = (typeof ExportDestinations)[number];

export const ExportFormats = ["CSV"] as const;
export type ExportFormatType = (typeof ExportFormats)[number];

export const ReportDataTypes = ["TOUCHPOINTS"] as const;
export type ReportDataType = (typeof ReportDataTypes)[number];

export const TriggerTypes = ["SCHEDULED"] as const;
export type TriggerType = (typeof TriggerTypes)[number];

export const TriggerSubTypes = ["TIME_BASED"] as const;
export type TriggerSubType = (typeof TriggerSubTypes)[number];
